import React, { useState } from 'react'
import { Label, FormGroup, Col } from 'reactstrap'
import Select from 'react-select'
import { connect } from 'react-redux'
import { handleUpdateProductMapping } from '../actions/productMappingActions'

const ProductMappingItem = ({ product, handleUpdateProductMapping }) => {
  let options = [
    { label: 'Unmanaged', value: 0 },
    { label: 'Managed', value: 1 },
  ]

  const handleChange = (newValue) => {
    setManagedValue(newValue)
    handleUpdateProductMapping(product, newValue)
  }

  const [managedValue, setManagedValue] = useState(product.selectedValue)
  return (
    <FormGroup row>
      <Col sm={2}></Col>
      <Col sm={5}>
        <Label for="Description">{product.label}</Label>
      </Col>
      <Col sm={3}>
        <Select onChange={handleChange} defaultValue={product.selectedValue} value={managedValue} options={options} />
      </Col>
      <Col sm={2}></Col>
    </FormGroup>
  )
}

const mapDispatchToProps = {
  handleUpdateProductMapping,
}

export default connect(null, mapDispatchToProps)(ProductMappingItem)
